import { BasicDataTemplate } from '@itau-loans-www/templates'
import ProposalLayout from 'layouts/Proposal'

const BasicData = () => {
  return (
    <ProposalLayout>
      <BasicDataTemplate />
    </ProposalLayout>
  )
}

export default BasicData
